import { Spinner } from '@heroui/react';
import React, { FC, useEffect, useState } from 'react';

import { ComposerHint } from './AiComposer.styled';

interface AiProgressProps {
  /** Faza pobierania zdjęć ze stocka po odpowiedzi modelu. */
  isImporting: boolean;
}

/**
 * Komunikaty zmieniające się w czasie oczekiwania.
 *
 * Model rozumujący liczy układ kilkanaście do kilkudziesięciu sekund i przez
 * ten czas nic się nie dzieje na ekranie. Sam kręcący się spinner każe wtedy
 * zgadywać, czy to jeszcze działa — kolejne zdania mówią wprost, że tak, i na
 * jakim etapie jesteśmy.
 */
const STEPS: { after: number; text: string }[] = [
  { after: 0, text: 'Generuję układ kreacji...' },
  { after: 8, text: 'Model rozkłada bloki na planszy...' },
  { after: 18, text: 'Jeszcze trochę cierpliwości, układ się liczy...' },
  { after: 32, text: 'Już prawie, składam ostatnie elementy...' },
  { after: 50, text: 'Trwa dłużej niż zwykle, ale wciąż czekam na odpowiedź...' },
];

export const AiProgress: FC<AiProgressProps> = ({ isImporting }) => {
  const [seconds, setSeconds] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => setSeconds((value) => value + 1), 1000);
    return () => clearInterval(timer);
  }, []);

  const step = [...STEPS].reverse().find((item) => seconds >= item.after) ?? STEPS[0];

  return (
    <div className="flex items-center gap-3 py-2">
      <Spinner size="sm" />
      <div>
        <p className="text-sm text-gray-800">
          {isImporting ? 'Pobieram wybrane zdjęcia ze stocka...' : step.text}
        </p>
        <ComposerHint>
          {isImporting
            ? 'Pobieramy tylko te zdjęcia, które model faktycznie wstawił w kreację.'
            : 'Nie zamykaj tego okna, wynik pojawi się na planszy.'}
        </ComposerHint>
      </div>
    </div>
  );
};
